







































































































































































































































































































































































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import SideBar from "@/employee/components/healthcareExpenseV2/SideBar.vue";
import Widget from "@/shared/components/Widget.vue";
import CategoryPill from "@/shared/components/CategoryPill.vue";
import {
  FamilyMember,
  FetchState,
  HsabExpenseCategory,
  HsabExpenseCategoryDisplay,
  HsabExpenseEvidenceShoeboxResponse,
  HsabExpenseFormSubmitMethod,
  HsabExpenseOriginator,
  HsabExpenseRequest,
  HsabExpenseResponse,
  HsabExpenseSubTypeResponse,
  HsabExpenseTypeResponse,
  HsabPayee,
  HsabRecipientType,
  HsabSsoDestination,
  HsabSubmitExpenseError,
  ManagedExpenseResponse,
  ManuallyMarkedAsPaidStatus,
  WexExpenseAccountType,
} from "@/shared/types";
import EvidenceUpload from "@/shared/components/expenseV2/EvidenceUpload.vue";
import DenialReason from "@/employee/components/landing-pages/hsabank/expense/HsabWexClaimDenial.vue";
import Button from "@/shared/components/ui/Button.vue";
import { useExpenseV2Store } from "@/employee/store/expenseV2";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useUserStore } from "@/shared/store/user";
import { useThemeStore } from "@/shared/store/theme";
import { formatCurrency } from "@/shared/currency.js";
import PayeeSelector from "@/employer/components/payees/PayeeSelector.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import moment from "moment";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import { useHsabExpenseEvidenceStore } from "@/employee/store/hsabExpenseEvidence";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useFamilyStore } from "@/employee/store/family";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import HsabExpenseSubmitConfirmation from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseSubmitConfirmation.vue";
import HsabExpensePaymentDetails from "@/employee/components/landing-pages/hsabank/expense/HsabExpensePaymentDetails.vue";
import HsabExpensePayFromDisplay from "@/employee/components/landing-pages/hsabank/expense/HsabExpensePayFromDisplay.vue";
import * as hsabExpenseCategoryUtility from "@/employee/Utilities/HsabExpenseCategoryUtility";
import _ from "lodash";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    },
    ManuallyMarkedAsPaidStatus () {
      return ManuallyMarkedAsPaidStatus;
    },
    FetchState () {
      return FetchState;
    }
  },
  components: {
    SsoDeepLink,
    Button,
    Checkbox,
    GenericLoadingSpinner,
    EvidenceUpload,
    DenialReason,
    CategoryPill,
    HsabExpenseEvidence,
    HsabExpensePayFromDisplay,
    HsabExpensePaymentDetails,
    HsabExpenseSubmitConfirmation,
    PayeeSelector,
    Widget,
    SideBar
  }
})
export default class HsabExpenseForm extends Vue {
  formatCurrency = formatCurrency;

  contactInformationStore = useContactInfoStore();
  themeStore = useThemeStore();
  expenseStore = useExpenseV2Store();
  userStore = useUserStore();
  hsabExpenseStore = useHsabExpenseStore();
  hsabExpenseEvidenceStore = useHsabExpenseEvidenceStore();
  hsabAccountsStore = useHsabAccountsStore();
  familyStore = useFamilyStore();
  featureFlagStore = useFeatureFlagStore();

  @Prop()
  expense: HsabExpenseResponse;

  @Prop()
  shoeboxExpenseEvidence: HsabExpenseEvidenceShoeboxResponse [];

  @Prop()
  readonly: boolean;

  @Prop()
  hideExpenseHeader: boolean;

  @Prop()
  createFromDebitCardTransaction: ManagedExpenseResponse;

  @Prop()
  overrideSaveButtonText: string;

  expenseForm: HsabExpenseRequest = { ...this.newExpense };
  showDeleteConfirmationModal = false;
  showSubmitConfirmationModal = false;
  isSaving = false;
  isUploadingFilesToSubmittedExpense = false;
  isTravelCostReimbursementEnabled = false;
  isReimbursing = false;
  transactionType = 0;
  disableSaveButtons = false;
  expenseSaving = false;
  currentlySelectedCategory: HsabExpenseCategoryDisplay = null;
  formSubmitMethod: HsabExpenseFormSubmitMethod = HsabExpenseFormSubmitMethod.save;
  currentPayFromOptions: string[] = [];

  get categoryPills (): HsabExpenseCategoryDisplay[] {
    if (this.isSubmittedExpenseEditable ||
        (this.expense && this.expense.originator === HsabExpenseOriginator.CarrierClaim)
        || (this.expense && this.expense.originator === HsabExpenseOriginator.DebitCard)) {
     return this.hsabExpenseStore.getCategoriesForUsersPlans.filter(t =>
         t.category === HsabExpenseCategory.Medical ||
         t.category === HsabExpenseCategory.Vision ||
         t.category === HsabExpenseCategory.Dental ||
         t.category === HsabExpenseCategory.Pharmacy);
    }
    return this.hsabExpenseStore.getCategoriesForUsersPlans;
  }

  hasValidCategory = {
    getMessage () {
      return "Select a valid category for the recipient.";
    },
    validate (value: HsabExpenseCategory, params: any) {
      const recipientType = params[0];
      const hasRecipient = recipientType === HsabRecipientType.Subscriber || recipientType === HsabRecipientType.Dependant;
      const isCategoryNullOrNone = value === undefined || value === null || value === HsabExpenseCategory.None;
      return !(hasRecipient && isCategoryNullOrNone);
    }
  };

  @Watch("expense")
  syncPropWithForm () {
    if (this.expense) {
      this.expenseForm = { ...this.expenseForm, ...this.expense };
      if (this.expense.numberOfMiles) {
        this.isTravelCostReimbursementEnabled = true;
      }
    } else if (this.createFromDebitCardTransaction) {
      this.expenseForm = { ...this.newExpense };
      this.expenseForm.amount = this.createFromDebitCardTransaction.amount;
      this.expenseForm.providerName = this.createFromDebitCardTransaction.displayText;
      this.expenseForm.dateOfService = this.createFromDebitCardTransaction.dateOfService;
      this.expenseForm.expenseCategory = this.createFromDebitCardTransaction.expenseCategory;
      this.expenseForm.linkedDebitCardTransactionId = this.createFromDebitCardTransaction.reimbursementId;
      this.expenseForm.isPayToPayee = true;
      this.expenseForm.payeeName = this.createFromDebitCardTransaction.displayText;

    } else {
      this.expenseForm = { ...this.newExpense };
      this.isTravelCostReimbursementEnabled = false;
    }
  }

  @Watch("expenseForm.isPayToPayee")
  updateContactInfo () {
    if (!this.expenseForm.isPayToPayee) {
      this.contactInformationStore.getContactInformation();
    }
  }

  created () {
    this.familyStore.initialize()
        .then(response => {
          if (response === undefined || response === null || response.length === 0) {
            if (!this.hsabAccountsStore.userHasActiveNotionalAccounts) {
              this.onRecipientChanged(null);
            }
          }
        });
  }

  beforeMount () {
    this.$validator.extend("required_to_save", this.validateRequiredToSave, { computesRequired: true });
    this.$validator.extend("required_to_submit", this.validateRequiredToSubmit, { computesRequired: true });
    this.$validator.extend("hasValidCategory", this.hasValidCategory);
  }

  mounted () {
    this.syncPropWithForm();
    this.hsabExpenseStore.loadExpenseCategories().then(
        _ => {
          this.setExpenseCategoryOnMounted();
        }
    );
  }

  get isFieldReadOnly (): boolean {
    return this.readonly && !this.isSubmittedExpenseEditable;
  }

  get isAmountDisabled (): boolean {
    return this.readonly || this.hasExternalId || this.isLinkedToDebitCardTransaction;
  }

  get showPaymentFields () {
    return !this.isLinkedToDebitCardTransaction && this.expenseForm.manuallyMarkedAsPaidStatus !== ManuallyMarkedAsPaidStatus.MarkedAsPaid;
  }
  get isLinkedToDebitCardTransaction () {
    return this.expenseForm.linkedDebitCardTransactionId !== undefined
        && this.expenseForm.linkedDebitCardTransactionId !== null
        && this.expenseForm.linkedDebitCardTransactionId > 0;
  }

  get showExpenseTypeDropdown () {
    return !this.isFieldReadOnly
        && !this.hsabExpenseStore.isCategoryDataLoading
        && this.hsabExpenseStore.isCategoryDataLoaded
        && (this.currentlySelectedCategory && this.currentlySelectedCategory.showTypeSelector);
  }

  get showExpenseSubtypeDropdown () {
    return !this.isFieldReadOnly && this.hsabExpenseStore.isCategoryDataLoaded && !this.isStringNullOrEmpty(this.expenseForm.expenseType);
  }

  get showReimburseTravelCosts () {
    return this.isMedicalCategorySelected && !this.isLinkedToDebitCardTransaction && this.expenseForm.manuallyMarkedAsPaidStatus !== ManuallyMarkedAsPaidStatus.MarkedAsPaid;
  }

  get showRequestRecurring () {
    return this.hsabAccountsStore.userHasActiveNotionalAccounts &&
        this.payFromHasNotionalOption &&
        (!this.expense || this.expense.originator !== HsabExpenseOriginator.CarrierClaim);
  }

  get showEobNumber () {
    return this.expense && !this.isStringNullOrEmpty(this.expense.externalReferenceId);
  }

  get showSaveButton () {
    return this.isSubmittedExpenseEditable || !this.readonly;
  }

  get showSubmitButton () {
    return !this.readonly && !this.isLinkedToDebitCardTransaction && !(this.expenseForm && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid);
  }

  get hasExternalId () {
    return this.expense && !this.isStringNullOrEmpty(this.expense.externalExpenseId);
  }

  get showManuallyPaidOption () {
    return this.expense && this.expense.originator === HsabExpenseOriginator.CarrierClaim;
  }

  get newExpense (): HsabExpenseRequest {
    return {
      hsabExpenseId: null,
      expenseName: "",
      providerName: "",
      amount: 0,
      comment: "",
      dateOfService: this.defaultDateOfExpense,
      isPayToPayee: false,
      payeeName: "",
      payeeMemberNumber: "",
      payeeAddress1: "",
      payeeAddress2: "",
      payeeCity: "",
      payeeStateCode: "",
      payeeZipCode: "",
      expenseCategory: this.hsabAccountsStore.userHasActiveNotionalAccounts ? HsabExpenseCategory.Unknown : HsabExpenseCategory.Medical,
      expenseType: "",
      expenseSubType: "",
      expenseSubTypeDisplayName: "",
      numberOfMiles: 0,
      mileageDollarValue: null,
      stagedFilesForUpload: [],
      manuallyMarkedAsPaidStatus: ManuallyMarkedAsPaidStatus.NotMarkedAsPaid,
      recipientExternalId: null,
      recipientType: this.hsabAccountsStore.userHasActiveNotionalAccounts && this.recipients.length > 0 ? HsabRecipientType.None : HsabRecipientType.Subscriber,
      isRecurring: false,
      hsabExpenseEvidenceShoeboxIds: this.getHsabExpenseEvidenceShoeboxIds(),
    };
  }

  get uploadFileCount () {
    let count = 0;
    if (this.expense && this.expense.expenseEvidence) {
      count += this.expense.expenseEvidence.length;
    }
    if (this.expenseForm.stagedFilesForUpload) {
      count += this.expenseForm.stagedFilesForUpload.length;
    }
    return count;
  }

  get canDelete () {
    return !this.readonly &&
        this.expense &&
        this.expense.originator === HsabExpenseOriginator.Consumer;
  }

  get recipientDisplay () {
    if (this.expense && this.expense.importedRecipients && this.expense.importedRecipients.length > 0) {
      return this.expense.importedRecipients.map(t => {
        return t.firstName + " " + t.lastName;
      }).join("\n");
    } else if (!this.isStringNullOrEmpty(this.expenseForm.recipientExternalId)) {
      const recipient = this.currentRecipient;
      return recipient.firstName + " " + recipient.lastName;
    }
    return this.subscriberDisplay;
  }

  getRecipientDisplayString (recipient: FamilyMember): string {
    return recipient.firstName + " " + recipient.lastName +
        (recipient.dateOfBirth ? " (" +
            moment(recipient.dateOfBirth).format("MM/DD/YYYY") + ")" : "");
  }

  get currentRecipient () {
    return this.familyStore.getFamilyMemberByExternalId(this.expenseForm.recipientExternalId);
  }

  get isMedicalCategorySelected () {
    return this.currentlySelectedCategory
        && this.currentlySelectedCategory.category === HsabExpenseCategory.Medical;
  }

  get isFormSubmitMethodSaveAndSubmit () {
    return this.formSubmitMethod === HsabExpenseFormSubmitMethod.saveAndSubmit;
  }

  get isFormSubmitMethodSave () {
    return this.formSubmitMethod === HsabExpenseFormSubmitMethod.save;
  }

  get isAddingReceiptsAllowed () {
    if (!this.expense) {
      // creating new expense
      return true;
    }

    return this.expense.isFileUploadAllowed;
  }
  get eligibleAmountValidator () {

    return {
      required: true,
      decimal: 2,
      min_value_usd: 0.01
    };
  }

  get dateOfServiceAsMoment () {
    return moment(this.expenseForm.dateOfService);
  }

  get hasDenialReasons (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.denialReasons
        && this.expense.reimbursement.denialReasons.length > 0;
  }

  get isAddingAdditionalEvidence () {
    return this.expenseForm && this.expenseForm.stagedFilesForUpload.length > 0;
  }

  get isExpenseSubmitted (): boolean {
    return this.expense && this.expense.isSubmitted;
  }

  get isSubmittedExpenseEditable (): boolean {
    return this.expense && this.expense.isSubmitted && this.expense.reimbursement.planName === "Health Savings Account";
  }

  get isExpenseSubmittedToHsa (): boolean {
    return this.expense &&
        this.expense.isSubmitted &&
        this.expense.reimbursement &&
        this.expense.reimbursement.isHsaReimbursement;
  }

  get expenseTypesForSelectedCategory () {
    let items = this.hsabExpenseStore.getExpenseTypesAndSubtypesByCategory(this.expenseForm.expenseCategory);
    if (this.expenseForm.expenseCategory === HsabExpenseCategory.Dental || this.expenseForm.expenseCategory === HsabExpenseCategory.Vision) {
      items = hsabExpenseCategoryUtility.removeItemsIfUserHasLimitedFsaPlan(this.hsabAccountsStore.accounts, items);
    }
    return items;
  }

  get subTypesForCurrentExpenseType () {
    if (this.isStringNullOrEmpty(this.expenseForm.expenseCategory)
        || this.isStringNullOrEmpty(this.expenseForm.expenseType)) {
      return [];
    }
    const expenseType = this.hsabExpenseStore.getExpenseTypeByCategoryAndType(
        this.expenseForm.expenseCategory,
        this.expenseForm.expenseType);
    if (!expenseType) {
      return [];
    }
    return expenseType.expenseSubTypes;
  }

  get expenseTypeDropdownLabel () {
    return this.expenseForm.expenseType ? this.truncateIfTooSmallForWidth(this.expenseForm.expenseType) : "Select a type";
  }

  get subTypeDropdownLabel () {
    if (this.expenseForm.expenseSubTypeDisplayName) {
      return this.truncateIfTooSmallForWidth(this.expenseForm.expenseSubTypeDisplayName);
    }
    if (this.expenseForm.expenseSubType) {
      return this.truncateIfTooSmallForWidth(this.expenseForm.expenseSubType);
    }
    return "Select a subtype";
  }

  get isHsaOnly () {
    const userHasHsa = this.hsabAccountsStore.userHasHsaAccount;
    const userHasNotional = this.hsabAccountsStore.userHasActiveNotionalAccounts;
    return (!userHasNotional && userHasHsa);
  }

  get isFileUploadRequiredForSubmit (): boolean {
    if (this.expense && this.expense.originator === HsabExpenseOriginator.CarrierClaim) {
      return false;
    }

    return this.payFromHasNotionalOption;
  }

  get payFromHasNotionalOption (): boolean {
    return this.currentPayFromOptions.length > 1
        || (this.currentPayFromOptions.length === 1 && this.currentPayFromOptions[0] !== "HSA");
  }

  get today (): string {
    return moment().format("MM/DD/YYYY");
  }

  get oldestShoeboxReceiptDate (): string {
    if (this.hasShoeboxEvidenceAttached) {
       const dateStrings = this.shoeboxExpenseEvidence.map(x => x.dateUploaded);
       const dates = dateStrings.map(dateStr => new Date(dateStr));
       dates.sort((a, b) => a.getTime() - b.getTime());
       const oldestDate = dates[0];
       return moment(oldestDate).format("MM/DD/YYYY");
    }
    else return null;
  }

  get defaultDateOfExpense (): string {
     if (! this.oldestShoeboxReceiptDate) {
        return this.today;
     }
     else return this.oldestShoeboxReceiptDate;
  }
  get disableSubmitButton () {
    return this.isSaving
        || this.disableSaveButtons
        || !this.hsabAccountsStore.userHasAnyActiveAccount
        || (this.expense
            && this.expense.originator === HsabExpenseOriginator.CarrierClaim
            && this.expenseForm.manuallyMarkedAsPaidStatus !== ManuallyMarkedAsPaidStatus.NotMarkedAsPaid);
  }

  get submitButtonTooltip () {
    if (this.expense
        && this.expense.originator === HsabExpenseOriginator.CarrierClaim
        && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid) {
      return "Cannot submit an expense that has been marked as paid";
    } else if (this.expense
        && this.expense.originator === HsabExpenseOriginator.CarrierClaim
        && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.Unknown) {
      return "Please select if this claim has already been paid or not";
    }
    return "";
  }
  get receiptRequiredToSubmit () {
    return this.isFileUploadRequiredForSubmit && this.uploadFileCount === 0 && !this.hasShoeboxEvidenceAttached;
  }

  getHsabExpenseEvidenceShoeboxIds () {
    if (this.hasShoeboxEvidenceAttached) {
     return this.shoeboxExpenseEvidence.map(x => x.hsabExpenseEvidenceShoeboxId);
    }
    else return null;
  }

  get hasShoeboxEvidenceAttached (): boolean {
    return this.shoeboxExpenseEvidence && this.shoeboxExpenseEvidence.length > 0;
  }

  setExpenseCategoryOnMounted () {
    if (this.categoryPills.length > 0 && this.expense && this.isStringNullOrEmpty(this.expense.expenseCategory)) {
      // existing expense w/out a category selected
      if (!this.hsabAccountsStore.userHasActiveNotionalAccounts) {
        this.onExpenseCategorySelected(this.categoryPills[0]);
      }
    } else if (this.categoryPills.length > 0 && this.expense && !this.isStringNullOrEmpty(this.expense.expenseCategory)) {
      // existing expense with a category selected
      this.onExpenseCategorySelected(this.categoryPills.find(x => x.category === this.expense.expenseCategory));
      this.expenseForm.expenseType = this.expense.expenseType;
      this.expenseForm.expenseSubType = this.expense.expenseSubType;
      this.expenseForm.expenseSubTypeDisplayName = this.expense.expenseSubTypeDisplayName;
    } else if (this.categoryPills.length > 0 && !this.expense) {
      // new expense form
      if (!this.hsabAccountsStore.userHasActiveNotionalAccounts) {
        this.onExpenseCategorySelected(this.categoryPills[0]);
      }
    }
  }

  getExpensePayeeData (): HsabPayee {
    if (this.expenseForm.hsabExpenseId && this.expenseForm.hsabExpenseId > 0 && this.expenseForm.isPayToPayee) {
      return {
        payeeName: this.expenseForm.payeeName,
        memberAccountNumber: this.expenseForm.payeeMemberNumber,
        address1: this.expenseForm.payeeAddress1,
        address2: this.expenseForm.payeeAddress2,
        city: this.expenseForm.payeeCity,
        stateCode: this.expenseForm.payeeStateCode,
        zip: this.expenseForm.payeeZipCode,
      };
    } else {
      return null;
    }
  }

  handleCancelAction () {
    this.expenseForm = { ...this.expense, stagedFilesForUpload: [] };
    this.handleCloseAction();
  }

  handleCloseAction () {
    this.$emit("close-action");
  }

  closeDeleteConfirmationModal () {
    this.showDeleteConfirmationModal = false;
  }

  confirmDelete () {
    this.hsabExpenseStore.deleteExpense(this.expense.hsabExpenseId);
    this.closeDeleteConfirmationModal();
    this.handleCloseAction();
  }

  confirmSubmit () {
    this.expenseSaving = true;

    const managedExpensesStore = useManagedExpenseStore();
    this.hsabExpenseStore.CreateOrUpdateExpenseAndSubmitForReimbursement(this.expenseForm)
        .then(_ => {
          this.showSubmitConfirmationModal = false;
          this.expenseSaving = false;
          this.handleCloseAction();
        })
        .catch(failedStep => {
          switch (failedStep) {
            case HsabSubmitExpenseError.CreateExpense:
              break;
            case HsabSubmitExpenseError.UploadFiles:
            case HsabSubmitExpenseError.SubmitForReimbursement:
              this.handleCloseAction();
              managedExpensesStore.reloadCurrentPage();
              break;
          }

          this.expenseSaving = false;
        });
  }

  handleReimburseAction () {
    this.formSubmitMethod = HsabExpenseFormSubmitMethod.saveAndSubmit;
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }

      this.showSubmitConfirmationModal = true;
    });
  }

  addFiles (files) {
    this.expenseForm.stagedFilesForUpload = files;
  }

  handleSaveAction () {
    this.formSubmitMethod = HsabExpenseFormSubmitMethod.save;
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }
      this.isSaving = true;
      if (!this.expenseForm.isPayToPayee) {
        this.clearPayeeFormData();
      }
      this.hsabExpenseStore.saveExpense(this.expenseForm)
          .then(() => {
            this.isSaving = false;
            this.handleCloseAction();
            const managedExpensesStore = useManagedExpenseStore();
            managedExpensesStore.reloadCurrentPage();
          });

    });
  }

  handleAddFilesAfterSubmitted () {
    if (!this.expense || !this.expenseForm || !this.expenseForm.stagedFilesForUpload) {
      return;
    }

    this.isUploadingFilesToSubmittedExpense = true;
    this.hsabExpenseEvidenceStore.UploadFilesToSubmittedHsabExpense(
            this.expense.hsabExpenseId,
            this.expenseForm.stagedFilesForUpload,
            this.expense.reimbursement.isHsaReimbursement)
        .then(_ => {
          const managedExpensesStore = useManagedExpenseStore();
          managedExpensesStore.reloadCurrentPage();
          this.isUploadingFilesToSubmittedExpense = false;
          this.handleCloseAction();
        })
        .catch(err => {
          this.isUploadingFilesToSubmittedExpense = false;
        });
  }

  truncateIfTooSmallForWidth (text: string) {
    const widthPerCharNeeded = 10;
    const maxLength = Math.round(window.innerWidth / 10) - 3;
    if (window.innerWidth < text.length * widthPerCharNeeded) {
      return text.slice(0, maxLength) + "...";
    }

    return text;
  }

  clearPayeeFormData () {
    this.expenseForm.payeeName = "";
    this.expenseForm.payeeMemberNumber = "";
    this.expenseForm.payeeAddress1 = "";
    this.expenseForm.payeeAddress2 = "";
    this.expenseForm.payeeCity = "";
    this.expenseForm.payeeStateCode = "";
    this.expenseForm.payeeZipCode = "";
  }

  onPayeeSelected (payee: HsabPayee) {
    if (payee) {
      this.expenseForm.payeeName = payee.payeeName;
      this.expenseForm.payeeMemberNumber = payee.memberAccountNumber;
      this.expenseForm.payeeAddress1 = payee.address1;
      this.expenseForm.payeeAddress2 = payee.address2;
      this.expenseForm.payeeCity = payee.city;
      this.expenseForm.payeeStateCode = payee.stateCode;
      this.expenseForm.payeeZipCode = payee.zip;
    } else {
      this.clearPayeeFormData();
    }
  }

  onPayeeEditStateChanged (isEditing: boolean) {
    this.disableSaveButtons = isEditing;
  }

  readonly payTypes = [
    { text: "Reimburse myself", value: false },
    { text: "Pay someone else", value: true }
  ];

  onTravelReimbursementChanged () {
    this.$validator.errors.remove("Number of miles");
    this.$validator.errors.remove("Mileage dollar value");
  }

  onTravelCostReimbursementEnabledChanged (val) {
    if (val === false) {
      this.expenseForm.numberOfMiles = undefined;
    }
  }

  onExpenseCategorySelected (categoryDisplay) {
    this.currentlySelectedCategory = categoryDisplay;
    this.expenseForm.expenseType = null;
    this.expenseForm.expenseSubType = null;

    if (categoryDisplay === undefined || categoryDisplay === null) {
      return;
    }

    this.expenseForm.expenseCategory = categoryDisplay.category;
    if (categoryDisplay.external !== WexExpenseAccountType.Medical) {
      this.isTravelCostReimbursementEnabled = false;
      this.expenseForm.numberOfMiles = null;
    }

    if (!this.isHsaOnly) {
      const expenseTypes = this.expenseTypesForSelectedCategory;

      if (expenseTypes.length === 1) {
        this.onExpenseTypeSelected(expenseTypes[0].expenseType);
      } else if (categoryDisplay.defaultTypeWhenSelected) {
        const shouldSelect = expenseTypes.find(x => x.expenseType === categoryDisplay.defaultTypeWhenSelected);
        if (shouldSelect) {
          this.onExpenseTypeSelected(shouldSelect.expenseType);
        }
      }
    }
  }

  onExpenseTypeSelected (expenseType) {
    Vue.set(this.expenseForm, "expenseType", expenseType);
    const selectSubType = this.currentlySelectedCategory.defaultSubTypeWhenSelected && this.currentlySelectedCategory.defaultTypeWhenSelected === expenseType ?
        this.currentlySelectedCategory.defaultSubTypeWhenSelected(this.hsabAccountsStore.accounts) :
        null;

    const subTypes = this.subTypesForCurrentExpenseType;
    if (subTypes.length === 1) {
      this.onExpenseSubTypeSelected(subTypes[0]);
    } else if (selectSubType) {
      this.onExpenseSubTypeSelected({
        subTypeName: selectSubType,
        customDisplayName: selectSubType,
      });
    } else {
      this.onExpenseSubTypeSelected(null);
    }
  }

  onExpenseSubTypeSelected (subType) {
    if (subType) {
      Vue.set(this.expenseForm, "expenseSubType", subType.subTypeName);
      Vue.set(this.expenseForm, "expenseSubTypeDisplayName", subType.customDisplayName);
    } else {
      Vue.set(this.expenseForm, "expenseSubType", "");
      Vue.set(this.expenseForm, "expenseSubTypeDisplayName", "");
    }
  }

  isNullEmptyOrZero (val) {
    return val === undefined || val === null || val === "" || val === 0;
  }

  validateRequiredToSave (x) {
    return {
      valid: this.isFormSubmitMethodSave ? (x !== undefined && x !== null && x !== "") : true,
      data: {
        required: this.isFormSubmitMethodSave
      }
    };
  }

  validateRequiredToSubmit (x) {
    return {
      valid: this.isFormSubmitMethodSaveAndSubmit ? (x !== undefined && x !== null && x !== "" && x !== HsabExpenseCategory.Unknown) : true,
      data: {
        required: this.isFormSubmitMethodSaveAndSubmit
      }
    };
  }

  isStringNullOrEmpty (str) {
    return str === undefined || str === null || str === "";
  }

  onPayFromChange (options: string[]) {
    this.currentPayFromOptions = options;
  }

  getPlansEligibleForType (type: HsabExpenseTypeResponse) {
    let plans = [];
    _.forEach(type.expenseSubTypes, x => {
      _.forEach(x.planEligibility, e => {
        if (this.dateOfServiceAsMoment.isSameOrAfter(e.eligibleStartDate)) {
          if (e.planName === "HEALTH SAVINGS ACCOUNT") {
            plans.push("HSA");
          } else {
            plans.push(e.planName);
          }
        }
      });
    });
    plans = _.uniq(plans);

    if (plans.length > 1) {
      return "Multiple Plan Options";
    } else if (plans.length > 0) {
      return plans[0];
    } else {
      return "Unknown";
    }
  }

  getPlansEligibleForSubType (subtype: HsabExpenseSubTypeResponse) {
    let plans = [];
    _.forEach(subtype.planEligibility, e => {
      if (this.dateOfServiceAsMoment.isSameOrAfter(e.eligibleStartDate)) {
        if (e.planName === "HEALTH SAVINGS ACCOUNT") {
          plans.push("HSA");
        } else {
          plans.push(e.planName);
        }
      }
    });
    plans = _.uniq(plans);

    if (plans.length > 1) {
      return "Multiple Plan Options";
    } else if (plans.length > 0) {
      return plans[0];
    } else {
      return "Unknown";
    }
  }

  get showPlanOptionsInDropdown () {
    return this.hsabAccountsStore.allActiveHsabAccounts.length > 1;
  }

  get recipients () {
    if (this.familyStore.familyMembers) {
      return _.orderBy(this.familyStore.familyMembers, (o: any) => {
        return moment(o.dateOfBirth, "DD-MM-YYYY");
      }, ["desc"]);
    }
    return [];
  }
  get isRecipientsReadOnly () {
    if (this.isFieldReadOnly
        || (this.expense && this.expense.importedRecipients && this.expense.importedRecipients.length > 0)
        || this.recipients.length === 0) {
      return true;
    }
    return false;
  }

  get subscriberDisplay () {
    return this.contactInformationStore.contactInformation.firstName + " " + this.contactInformationStore.contactInformation.lastName;
  }

  onRecipientChanged (dep: FamilyMember) {
      if (dep) {
        Vue.set(this.expenseForm, "recipientType", HsabRecipientType.Dependant);
        Vue.set(this.expenseForm, "recipientExternalId", dep.externalId);
      }
      else {
        Vue.set(this.expenseForm, "recipientType", HsabRecipientType.Subscriber);
        Vue.set(this.expenseForm, "recipientExternalId", null);
      }
    this.validateCategories();
  }

  validateCategories () {
    if (this.expenseForm.recipientType === HsabRecipientType.Subscriber &&
        this.expenseForm.expenseCategory === HsabExpenseCategory.DependentCare) {
      this.expenseForm.expenseCategory = HsabExpenseCategory.None;
    }
    if (this.expenseForm.recipientType === HsabRecipientType.Dependant &&
        (this.expenseForm.expenseCategory === HsabExpenseCategory.MassTransit ||
            this.expenseForm.expenseCategory === HsabExpenseCategory.Parking)) {
      this.expenseForm.expenseCategory = HsabExpenseCategory.None;
    }
  }

  get recipientText () {
    switch (this.expenseForm.recipientType) {
      case HsabRecipientType.Dependant:
        return this.getRecipientDisplayString(this.currentRecipient);
      case HsabRecipientType.Subscriber:
        return this.subscriberDisplay;
      case HsabRecipientType.None:
      default:
        return "Select a recipient";
    }
  }

  disableCategoryByRecipient (category) {
    if (this.expenseForm.recipientType === HsabRecipientType.Subscriber
        && category === HsabExpenseCategory.DependentCare) {
      return true;
    } else {
      return this.expenseForm.recipientType === HsabRecipientType.Dependant
          && (category === HsabExpenseCategory.MassTransit || category === HsabExpenseCategory.Parking);
    }
  }

  get isRecipientRequiredToSubmit () {
    return this.expenseForm.recipientType !== HsabRecipientType.Subscriber;
  }
}
